export default __webpack_public_path__ + "static/media/OmaduroChurchillClosed.2059c53a.jpg";